$('body').on('click', '.files-uploader .select-files', function () {
    var uploader = $(this).parents('.files-uploader');
    uploader.find('input[type="file"]').trigger('click');
    return false;
});

$('body').on('click', '.files-uploader .remove-file', function () {
    $(this).parents('.file').remove();
    return false;
});

function filesUploaderAddUploadFile(uploader, file) {
    var fileContent = `<div class="upload-progress">
		<div class="progress-bar">
			<div class="current-progress"></div>
		</div>
	</div>

	<div class="meta">
		<a href="" class="remove-file icon-trash"></a>
		<p data-default="Please choose a file">Please choose a file</p>
	</div>

	<input type="hidden" name="${uploader.attr('data-file')}[]" class="">
	<input type="hidden" name="${uploader.attr('data-file')}_file[]" class="">`;

    var newFile = $('<div>', {
        class: 'file uploading',
        html: fileContent
    });

    $('.files', uploader).append(newFile);

    var payload = new FormData();
    payload.append('file', file);
    payload.append('_token', $('meta[name="csrf-token"]').attr('content'));
    if (uploader.attr('data-mode')) {
        payload.append("mode", uploader.attr("data-mode"));
    }

    $.ajax({
        xhr: function () {
            var xhr = new window.XMLHttpRequest();
            xhr.upload.addEventListener('progress', function (e) {
                if (e.lengthComputable) {
                    var percentComplete = e.loaded / e.total;
                    percentComplete = Math.round(percentComplete * 100);

                    newFile.find('.current-progress').css({
                        width: percentComplete + '%'
                    });

                    if (percentComplete === 100) {
                        newFile.removeClass('uploading');
                        newFile.find('.meta p').html('Processing File');
                    }
                }
            }, false);
            return xhr;
        },
        type: 'POST',
        url: uploader.attr('data-url'),
        data: payload,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function (data) {
            // console.log(data);

            if (!data.success) {
                newFile.find('.meta p').html('Error: ' + data.message);
                return false;
            }

            newFile.removeClass('uploading');
            newFile.addClass('has-file');
            newFile.find('.meta p').html(data.name);
            newFile.find('input[name="' + uploader.attr('data-file') + '[]"]').val(data.file);
            newFile.find('input[name="' + uploader.attr('data-file') + '_file[]"]').val(data.file_file);
            newFile.find('.current-progress').css({
                width: '0%'
            });
        },
        error: function (request) {
            console.log(request.responseText);
        }
    });
}

$('body').on('change', '.files-uploader input[type="file"]', function () {
    var input = $(this);
    var uploader = input.parents('.files-uploader');
    var files = input[0].files;

    $.each(files, function (index, file) {
        filesUploaderAddUploadFile(uploader, file);
    });
    return false;
});